import axios from 'axios';

const API_URL = '/api/enrollments/';

// Get user enrollments
const getUserEnrollments = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.get(API_URL, config);
  return response.data;
};

// Enroll in a course
const enrollInCourse = async (courseId, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.post(API_URL, { course: courseId }, config);
  return response.data;
};

// Get enrollment by ID
const getEnrollmentById = async (enrollmentId, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.get(API_URL + enrollmentId, config);
  return response.data;
};

const enrollmentService = {
  getUserEnrollments,
  enrollInCourse,
  getEnrollmentById,
};

export default enrollmentService;